import InventoryDTO from '@src/adapters/dto/inventory/InventoryDTO';
import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  filter: string;
  pageSize: number;
  currentPage: number;
}

interface Result {
  inventories: InventoryDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/inventory',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindInventoriesLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindInventoriesLazy;
